<template>
  <div class="modal-card orgin">
    <header class="modal-card-head">
      <p class="modal-card-title" style="color: whitesmoke; text-align: left">処方値変更履歴</p>
    </header>
    <section class="modal-card-body" style="margin-top:-20px;">
      <table style="border:1">
        <thead>
          <tr>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:10%; padding-left:5px;">変更日時</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:12%; padding-left:5px;">更新者</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:8%;  padding-left:5px;">品目コード</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:10%; padding-left:5px;">品目シリアル</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:6%;  padding-left:5px;">変更種別</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:14%; padding-left:5px;">変更項目</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:10%; padding-left:5px;">変更前</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:10%; padding-left:5px;">変更後</td>
            <td class="fixed01" style="font-size:16px; padding-top:20px; width:20%; padding-left:5px;">変更理由</td>
          </tr>
        </thead>
        <tbody v-for="(preTarget, index) in preEditHistoryList" v-bind:key="index" style="border-bottom: 1px solid lightgray;">
          <tr v-if="index != 0 && preTarget.id != preEditHistoryList[index - 1].id" style="height:8px;">
            <td colspan="9" style="width:100%;backgroundColor: #209cee;height:8px;"></td>
          </tr>
          <tr>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:10%;">{{ preTarget.updatedDay }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:12%; word-break:break-all;">{{ preTarget.staffName }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:8%;  word-break:break-all;">{{ preTarget.machineReplaceProductCode ? preTarget.machineReplaceProductCode : preTarget.itemCode }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:10%; word-break:break-all;">{{ preTarget.machineReplaceSerialNumber ? preTarget.machineReplaceSerialNumber : preTarget.serial }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:6%;">{{ preTarget.type }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:14%;word-break:break-all;">{{ preTarget.displayName }}
              <span class="machineReplace" v-if="preTarget.displayOrder == null && preTarget.displayName == '器械交換'"/>
              <span class="subContentsEtoNE" v-else-if="preTarget.displayOrder == null && preTarget.displayName != '療法（呼吸のみ）' && preTarget.beforeValue == '有り' && preTarget.afterValue == '無し'"/>
              <span class="subContentsNEtoE" v-else-if="preTarget.displayOrder == null && preTarget.displayName != '療法（呼吸のみ）' && preTarget.beforeValue == '無し' && preTarget.afterValue == '有り'"/>
            </td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:10%;word-break:break-all;">{{ preTarget.beforeValue }}</td>
            <td style="font-size: 16px; border-right:solid 1px lightgray; padding-left:5px; width:10%;word-break:break-all;">{{ preTarget.afterValue }}</td>
            <td style="font-size: 16px; padding-left:5px; width:20%; word-break:break-all;">{{ preTarget.doctorChangeReason }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">閉じる</button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "AppPrescriptionHistoryModal",
  props: ["targetData"],
  methods: {
    close: function(event) {
      this.$parent.close();
    },
    back: function(event) {}
  },
  data() {
    return {
      preEditHistoryList:this.$props.targetData
    };
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
.orgin {
  margin-top:2% !important;
  margin-left:5% !important;
  width:90% !important;
  height:90% !important;
}
.machineReplace::after
{
content: "器械交換";
width:40px;
height: 30px;
background-color: red;
padding:1px 2px 1px 2px;
margin: -4px 0 0 2px;
font-size: 11px;
color: #ffff;
vertical-align: text-top;
border-radius: 3px;
}
.subContentsEtoNE::after
{
content: "副項目";
width:35;
height: 16px;
background-color: blue;
padding:1px 2px 1px 2px;
margin: -4px 0 0 2px;
font-size: 11px;
color: #ffff;
vertical-align: text-top;
border-radius: 3px;
}
.subContentsNEtoE::after
{
content: "副項目";
width:35;
height: 16px;
background-color: green;
padding:1px 2px 1px 2px;
margin: -4px 0 0 2px;
font-size: 11px;
color: #ffff;
vertical-align: text-top;
border-radius: 3px;
}
.fixed01{
  position: sticky;
  top: 0;
  color: #333;
  background: #fff;
  &:before{
    content: "";
    position: absolute;
    top: 2px;
    left: 0px;
    width: 100%;
    height: 100%;
    border-bottom: 3px double lightgray;
    background: #fff;
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPrescriptionHistoryModal.vue